module.exports = __webpack_public_path__ + "img/price-offer-logo.a6dce38.svg";